(function () {
  const rules = Array.isArray(window.autoAddonRules) ? window.autoAddonRules : [];
  if (!rules.length) return;

  let isProcessing = false;
  let scheduled = null;

  function normalizeRules(rules) {
    return rules.map(rule => ({
      triggerVariantIds: (rule.triggerVariantIds || []).map(id => Number(id)),
      forbiddenVariantIds: (rule.forbiddenVariantIds || []).map(id => Number(id)),
      addonVariantId: Number(rule.addonVariantId),
      minCartTotal: rule.minCartTotal != null ? Number(rule.minCartTotal) : null,
      minTriggerQty: rule.minTriggerQty != null ? Number(rule.minTriggerQty) : null,
      requiresOtherProduct: rule.requiresOtherProduct === true
    }));
  }

  const normalizedRules = normalizeRules(rules);
  const allAddonVariantIds = normalizedRules.map(rule => Number(rule.addonVariantId));

  async function getCart() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    });
    return res.json();
  }

  async function addVariant(variantId, quantity) {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity,
          properties: {
            _auto_addon: 'true'
          }
        }]
      })
    });

    const text = await res.text();

    if (!res.ok) {
      throw new Error('cart/add.js falló: ' + text);
    }

    return JSON.parse(text);
  }

  async function changeCartLine(lineKey, quantity) {
    const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    });

    const text = await res.text();

    if (!res.ok) {
      throw new Error('cart/change.js falló: ' + text);
    }

    return JSON.parse(text);
  }

  function getTriggerQty(cart, triggerVariantIds) {
    if (!triggerVariantIds.length) return 0;

    return cart.items.reduce((total, item) => {
      if (triggerVariantIds.includes(Number(item.id))) {
        return total + Number(item.quantity || 0);
      }
      return total;
    }, 0);
  }

  function cartHasAnyTrigger(cart, triggerVariantIds) {
    if (!triggerVariantIds.length) return true;
    return cart.items.some(item => triggerVariantIds.includes(Number(item.id)));
  }

  function cartHasForbiddenTrigger(cart, forbiddenVariantIds) {
    if (!forbiddenVariantIds.length) return false;
    return cart.items.some(item => forbiddenVariantIds.includes(Number(item.id)));
  }

  function ruleMeetsTriggerQty(cart, rule) {
    if (rule.minTriggerQty == null) return true;
    return getTriggerQty(cart, rule.triggerVariantIds) >= rule.minTriggerQty;
  }

  function ruleMeetsOtherProduct(cart, rule) {
    if (!rule.requiresOtherProduct) return true;

    return cart.items.some(item => {
      const itemId = Number(item.id);
      const isTrigger = rule.triggerVariantIds.includes(itemId);
      const isAddon = itemId === rule.addonVariantId;

      return !isTrigger && !isAddon;
    });
  }

  function findManagedAddonLine(cart, variantId) {
    return cart.items.find(item => {
      return (
        Number(item.id) === Number(variantId) &&
        item.properties &&
        item.properties._auto_addon === 'true'
      );
    });
  }

  function findAnyCartLineByVariantId(cart, variantId) {
    return cart.items.find(item => Number(item.id) === Number(variantId));
  }

  function cartHasOtherGift(cart, currentAddonVariantId) {
    return cart.items.some(item => {
      const itemId = Number(item.id);
      return allAddonVariantIds.includes(itemId) && itemId !== Number(currentAddonVariantId);
    });
  }

  function ruleMeetsCartTotal(cart, rule) {
    if (rule.minCartTotal == null) return true;
    return Number(cart.total_price) >= rule.minCartTotal;
  }

  async function evaluateAllRules() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();

      const variantsToAdd = [];
      const lineKeysToRemove = [];

      normalizedRules.forEach(rule => {
        const hasTrigger = cartHasAnyTrigger(cart, rule.triggerVariantIds);
        const hasForbiddenTrigger = cartHasForbiddenTrigger(cart, rule.forbiddenVariantIds);
        const meetsTriggerQty = ruleMeetsTriggerQty(cart, rule);
        const meetsOtherProduct = ruleMeetsOtherProduct(cart, rule);
        const meetsTotal = ruleMeetsCartTotal(cart, rule);

        const managedAddonLine = findManagedAddonLine(cart, rule.addonVariantId);
        const anyAddonLine = findAnyCartLineByVariantId(cart, rule.addonVariantId);
        const otherGiftExists = cartHasOtherGift(cart, rule.addonVariantId);

        const ruleIsActive =
          hasTrigger &&
          !hasForbiddenTrigger &&
          meetsTriggerQty &&
          meetsOtherProduct &&
          meetsTotal;

        if (ruleIsActive && !anyAddonLine && !otherGiftExists) {
          variantsToAdd.push(rule.addonVariantId);
        }

        if ((!ruleIsActive || otherGiftExists) && managedAddonLine) {
          lineKeysToRemove.push(managedAddonLine.key);
        }
      });

      let changed = false;

      for (const variantId of variantsToAdd) {
        await addVariant(variantId, 1);
        changed = true;
      }

      for (const lineKey of lineKeysToRemove) {
        await changeCartLine(lineKey, 0);
        changed = true;
      }

      if (changed) {
        window.location.reload();
      }
    } catch (error) {
      console.error('[auto-addon] error evaluando reglas:', error);
    } finally {
      isProcessing = false;
    }
  }

  function scheduleEvaluation(delay = 500) {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(() => {
      evaluateAllRules();
    }, delay);
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    scheduleEvaluation(700);
  });

  document.addEventListener('change', function (event) {
    const target = event.target;

    const isQuantityInput =
      target.matches('input[name="updates[]"]') ||
      target.matches('input[name^="updates"]') ||
      target.matches('select[name="updates[]"]') ||
      target.matches('[data-quantity-input]');

    if (isQuantityInput) {
      scheduleEvaluation(700);
    }
  });

  document.addEventListener('click', function (event) {
    const el = event.target.closest(
      '[href*="/cart/change"], [data-cart-remove], [data-remove], .cart__remove, .js-qty__adjust, [name="minus"], [name="plus"]'
    );

    if (el) {
      scheduleEvaluation(700);
    }
  });

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear')
      ) {
        scheduleEvaluation(400);
      }
    } catch (e) {
      console.error('[auto-addon] error detectando fetch carrito:', e);
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', function () {
    scheduleEvaluation(0);
  });
})();

// (function () {
//   const rules = Array.isArray(window.autoAddonRules) ? window.autoAddonRules : [];
//   if (!rules.length) return;

//   let isProcessing = false;
//   let scheduled = null;

//   function normalizeRules(rules) {
//     return rules.map(rule => ({
//       triggerVariantIds: (rule.triggerVariantIds || []).map(id => Number(id)),
//       addonVariantId: Number(rule.addonVariantId),
//       minCartTotal: rule.minCartTotal != null ? Number(rule.minCartTotal) : null,
//       minTriggerQty: rule.minTriggerQty != null ? Number(rule.minTriggerQty) : null,
//       requiresOtherProduct: rule.requiresOtherProduct === true
//     }));
//   }

//   const normalizedRules = normalizeRules(rules);
//   const allAddonVariantIds = normalizedRules.map(rule => Number(rule.addonVariantId));

//   async function getCart() {
//     const res = await fetch(window.Shopify.routes.root + 'cart.js', {
//       headers: { Accept: 'application/json' }
//     });
//     return res.json();
//   }

//   async function addVariant(variantId, quantity) {
//     const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json'
//       },
//       body: JSON.stringify({
//         items: [{
//           id: Number(variantId),
//           quantity,
//           properties: {
//             _auto_addon: 'true'
//           }
//         }]
//       })
//     });

//     const text = await res.text();

//     if (!res.ok) {
//       throw new Error('cart/add.js falló: ' + text);
//     }

//     return JSON.parse(text);
//   }

//   async function changeCartLine(lineKey, quantity) {
//     const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json'
//       },
//       body: JSON.stringify({
//         id: lineKey,
//         quantity
//       })
//     });

//     const text = await res.text();

//     if (!res.ok) {
//       throw new Error('cart/change.js falló: ' + text);
//     }

//     return JSON.parse(text);
//   }

//   function getTriggerQty(cart, triggerVariantIds) {
//     if (!triggerVariantIds.length) return 0;

//     return cart.items.reduce((total, item) => {
//       if (triggerVariantIds.includes(Number(item.id))) {
//         return total + Number(item.quantity || 0);
//       }
//       return total;
//     }, 0);
//   }

//   function cartHasAnyTrigger(cart, triggerVariantIds) {
//     if (!triggerVariantIds.length) return true;
//     return cart.items.some(item => triggerVariantIds.includes(Number(item.id)));
//   }

//   function ruleMeetsTriggerQty(cart, rule) {
//     if (rule.minTriggerQty == null) return true;
//     return getTriggerQty(cart, rule.triggerVariantIds) >= rule.minTriggerQty;
//   }

//   function ruleMeetsOtherProduct(cart, rule) {
//     if (!rule.requiresOtherProduct) return true;

//     return cart.items.some(item => {
//       const itemId = Number(item.id);
//       const isTrigger = rule.triggerVariantIds.includes(itemId);
//       const isAddon = itemId === rule.addonVariantId;

//       return !isTrigger && !isAddon;
//     });
//   }

//   function findManagedAddonLine(cart, variantId) {
//     return cart.items.find(item => {
//       return (
//         Number(item.id) === Number(variantId) &&
//         item.properties &&
//         item.properties._auto_addon === 'true'
//       );
//     });
//   }

//   function findAnyCartLineByVariantId(cart, variantId) {
//     return cart.items.find(item => Number(item.id) === Number(variantId));
//   }

//   function cartHasOtherGift(cart, currentAddonVariantId) {
//     return cart.items.some(item => {
//       const itemId = Number(item.id);
//       return allAddonVariantIds.includes(itemId) && itemId !== Number(currentAddonVariantId);
//     });
//   }

//   function ruleMeetsCartTotal(cart, rule) {
//     if (rule.minCartTotal == null) return true;
//     return Number(cart.total_price) >= rule.minCartTotal;
//   }

//   async function evaluateAllRules() {
//     if (isProcessing) return;
//     isProcessing = true;

//     try {
//       const cart = await getCart();

//       const variantsToAdd = [];
//       const lineKeysToRemove = [];

//       normalizedRules.forEach(rule => {
//         const hasTrigger = cartHasAnyTrigger(cart, rule.triggerVariantIds);
//         const meetsTriggerQty = ruleMeetsTriggerQty(cart, rule);
//         const meetsOtherProduct = ruleMeetsOtherProduct(cart, rule);
//         const meetsTotal = ruleMeetsCartTotal(cart, rule);

//         const managedAddonLine = findManagedAddonLine(cart, rule.addonVariantId);
//         const anyAddonLine = findAnyCartLineByVariantId(cart, rule.addonVariantId);
//         const otherGiftExists = cartHasOtherGift(cart, rule.addonVariantId);

//         const ruleIsActive =
//           hasTrigger &&
//           meetsTriggerQty &&
//           meetsOtherProduct &&
//           meetsTotal;

//         if (ruleIsActive && !anyAddonLine && !otherGiftExists) {
//           variantsToAdd.push(rule.addonVariantId);
//         }

//         if ((!ruleIsActive || otherGiftExists) && managedAddonLine) {
//           lineKeysToRemove.push(managedAddonLine.key);
//         }
//       });

//       let changed = false;

//       for (const variantId of variantsToAdd) {
//         await addVariant(variantId, 1);
//         changed = true;
//       }

//       for (const lineKey of lineKeysToRemove) {
//         await changeCartLine(lineKey, 0);
//         changed = true;
//       }

//       if (changed) {
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error('[auto-addon] error evaluando reglas:', error);
//     } finally {
//       isProcessing = false;
//     }
//   }

//   function scheduleEvaluation(delay = 500) {
//     if (scheduled) clearTimeout(scheduled);
//     scheduled = setTimeout(() => {
//       evaluateAllRules();
//     }, delay);
//   }

//   document.addEventListener('submit', function (event) {
//     const form = event.target;
//     if (!form.matches('form[action*="/cart/add"]')) return;
//     scheduleEvaluation(700);
//   });

//   document.addEventListener('change', function (event) {
//     const target = event.target;

//     const isQuantityInput =
//       target.matches('input[name="updates[]"]') ||
//       target.matches('input[name^="updates"]') ||
//       target.matches('select[name="updates[]"]') ||
//       target.matches('[data-quantity-input]');

//     if (isQuantityInput) {
//       scheduleEvaluation(700);
//     }
//   });

//   document.addEventListener('click', function (event) {
//     const el = event.target.closest(
//       '[href*="/cart/change"], [data-cart-remove], [data-remove], .cart__remove, .js-qty__adjust, [name="minus"], [name="plus"]'
//     );

//     if (el) {
//       scheduleEvaluation(700);
//     }
//   });

//   const originalFetch = window.fetch;
//   window.fetch = async function (...args) {
//     const response = await originalFetch.apply(this, args);

//     try {
//       const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

//       if (
//         url.includes('/cart/add') ||
//         url.includes('/cart/update') ||
//         url.includes('/cart/change') ||
//         url.includes('/cart/clear')
//       ) {
//         scheduleEvaluation(400);
//       }
//     } catch (e) {
//       console.error('[auto-addon] error detectando fetch carrito:', e);
//     }

//     return response;
//   };

//   document.addEventListener('DOMContentLoaded', function () {
//     scheduleEvaluation(0);
//   });
// })();
